import { css } from "lit"

export const breadcrumbsStyles = css`
  /* Breadcrumbs — matches the previous (React) footer styling:
     frost background + tint-edge top border, olive links in the Avenir Medium
     face at 12px (underline on hover), and olive separators. */
  .breadcrumbs {
    background: #f3f3f1; /* frost */
    border-top: 1px solid rgba(16, 11, 0, 0.08); /* tint-edge */
    padding: 0.5rem 0;
  }

  .breadcrumbs-nav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .breadcrumb-link,
  .breadcrumb-current {
    font-family: 'Avenir LT W01_65 Medium1475532', 'Avenir', sans-serif;
    font-size: 0.75rem;
    line-height: 1.4;
  }

  .breadcrumb-link {
    color: #647a1c; /* link-copy */
    text-decoration: none;
  }

  .breadcrumb-link:hover {
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  .breadcrumb-current {
    color: #333333; /* body-copy — current page */
  }

  .breadcrumb-separator {
    margin: 0 0.75rem;
    color: #768d2f; /* primary-500 */
  }
`
